import { Box, Button, Grid, Typography, Stack } from "@mui/material";
import { Window, WindowActionsBar } from "@progress/kendo-react-dialogs";
import {
    ListBox,
    ListBoxToolbar,
    processListBoxData,
    processListBoxDragAndDrop
  } from "@progress/kendo-react-listbox";
import getSetDataService from "../../../../shared/common-utilities/services/getSetDataService";
import { useState, useEffect } from "react";

let service = getSetDataService();

const GrandSumTotalPopUp = (props) => {
    const { openModalFreeze, setOpenModalFreeze, colMeasureFilters, sendDataToParent } = { ...props };
    const SELECTED_FIELD = "selected";

    const [listBoxHeight, setListBoxHeight] = useState(450);
    const [filterWindowPos, setFilterWindowPos] = useState({ left: 0, top:  0, width: 650, height: 450 });
    const [isVisibleWindow, setIsVisibleWindow] = useState(false);
    let [measureFilters, setMeasureFilters] = useState(colMeasureFilters);

    useEffect(() => {
        if (openModalFreeze) {
            setIsVisibleWindow(true);
            setListBoxHeight(450);
            service.setWindowInitialPosition(650, 450, setFilterWindowPos);
        }
    }, [openModalFreeze])

    const sortColumnsOnItemClick = (event, data, connectedData) => {
        setMeasureFilters({
          ...measureFilters,
          [data]: measureFilters[data].map(item => {
            if (item.field === event.dataItem.field) {
              item[SELECTED_FIELD] = !item[SELECTED_FIELD];
            } else if (!event.nativeEvent.ctrlKey) {
              item[SELECTED_FIELD] = false;
            }
            return item;
          }),
          [connectedData]: measureFilters[connectedData].map(item => {
            item[SELECTED_FIELD] = false;
            return item;
          })
        });
    };

    const sortColumnsOnToolBarClick = (e) => {
        let toolName = e.toolName || '';
        let data = processListBoxData(measureFilters.measureColumnsData, measureFilters.movMeasureTableColumns, toolName, SELECTED_FIELD);
        setMeasureFilters({
            ...measureFilters,
            measureColumnsData: data.listBoxOneData,
            movMeasureTableColumns: data.listBoxTwoData
        })
    };

    const sortColumnsOnDragStart = e => {
        setMeasureFilters({
            ...measureFilters,
            draggedItem: e.dataItem
        });
    };

    const sortColumnsOnDrop = e => {
        let data = processListBoxDragAndDrop(
            measureFilters.measureColumnsData,
            measureFilters.movMeasureTableColumns,
            measureFilters.draggedItem,
            e.dataItem,
            "field"
        );
        setMeasureFilters({
            ...measureFilters,
            measureColumnsData: data.listBoxOneData,
            movMeasureTableColumns: data.listBoxTwoData
        });
    };

    const onMoveWindow = (event) => {
        service.onMoveWindow(event, filterWindowPos, setFilterWindowPos);
    };

    const onResizeWindow = (event) => {
        service.onResizeWindow(event, setFilterWindowPos);
        setListBoxHeight(event.height);
    }

    // Table Rows Popup OK function call
    const grandTotalSum = () => {
        sendDataToParent({ measureColumnsData: measureFilters.measureColumnsData, movMeasureTableColumns: measureFilters.movMeasureTableColumns });
        setOpenModalFreeze(false);
    }

    const closePopupFilter = () => {
        setOpenModalFreeze(false);
    };

    return (
        <>
            {(openModalFreeze && isVisibleWindow) && <Window title={"Grand Sum Total"} className='kendo-popup' modal={true} initialWidth={650} initialHeight={450} minWidth={650} minHeight={450} onClose={closePopupFilter} left={filterWindowPos.left} top={filterWindowPos.top} onMove={onMoveWindow} onResize={onResizeWindow} maximizeButton={() => { return null }} doubleClickStageChange={false}>
                <Grid sx={{ padding: 0 }}>
                    <Stack direction="row" spacing={1} className="customListBox"> 
                        <Box sx={{ width: "50%" }}>
                            <Typography variant="body2" gutterBottom sx={{ color: 'primary.main', fontWeight: 'bold' }}>Selected Columns</Typography>
                            <ListBox style={{ height: `${listBoxHeight - 150}px`, width: "100%" }}
                                data={measureFilters?.measureColumnsData}
                                textField="field"
                                selectedField={SELECTED_FIELD}
                                onItemClick={e => sortColumnsOnItemClick(e, 'measureColumnsData', 'movMeasureTableColumns')}
                                onDragStart={sortColumnsOnDragStart}
                                onDrop={sortColumnsOnDrop}
                                toolbar={() => {
                                    return <ListBoxToolbar tools={['moveUp', 'moveDown', 'transferTo', 'transferFrom', 'transferAllTo', 'transferAllFrom', 'remove']} data={measureFilters.measureColumnsData} dataConnected={measureFilters.movMeasureTableColumns} onToolClick={sortColumnsOnToolBarClick} />;
                                }}
                            />
                        </Box>
                        <Box sx={{ width: "50%" }}>
                            <Typography variant="body2" gutterBottom sx={{ color: 'primary.main', fontWeight: 'bold' }}>Columns Of Table</Typography>
                            <ListBox style={{ height: `${listBoxHeight - 150}px`, width: "100%" }}
                                data={measureFilters?.movMeasureTableColumns}
                                textField="field"
                                selectedField={SELECTED_FIELD}
                                onItemClick={e => sortColumnsOnItemClick(e, 'movMeasureTableColumns', 'measureColumnsData')}
                                onDragStart={sortColumnsOnDragStart}
                                onDrop={sortColumnsOnDrop}
                            />
                        </Box>
                    </Stack>
                </Grid>

                <WindowActionsBar>
                    <Button variant="contained" onClick={grandTotalSum} size="small">
                        OK
                    </Button>
                    <Button variant="outlined" onClick={() => { }} size="small">
                        Clear All
                    </Button>
                </WindowActionsBar>
            </Window>}
        </>
    );
}

export default GrandSumTotalPopUp;